/* eslint-disable */

import * as customerManagementService from "../../../services/customer";
import * as settings from "../../../services/settings";

import { Button, Card, Col, Form, Input, InputNumber, Modal, Row, Typography, Upload, notification } from "antd";
import React, { useEffect, useState } from "react";

import { useAccessToken } from "../../../contexts/AccessTokenContext";

const { TextArea } = Input;
const { Title } = Typography;
const { Dragger } = Upload;

const initPage = { limit: 10, page: 1, total: 1 };

export const ModelFormula = ({
  t,
  isModalOpen,
  handleOk,
  handleCancel,
  viewFormulaDataByOne,
  fetchCustomerFormula,
  setIsModalOpen,
  detailData,
}) => {
  const { accessToken } = useAccessToken();
  const [formCustomerFormula] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const setFormulaData = (data) => {
    if (isModalOpen) {
      let formula = data;
      formCustomerFormula.setFieldValue("threshold_a", formula.threshold_a);
      formCustomerFormula.setFieldValue("threshold_b", formula.threshold_b);
      formCustomerFormula.setFieldValue("threshold_c", formula.threshold_c);
      formCustomerFormula.setFieldValue("threshold_d", formula.threshold_d);
      formCustomerFormula.setFieldValue("threshold_e", formula.threshold_e);
      // Check formula volume is land or sea
      if (formula.app_customervolumeformula.length > 0) {
        const volumeFormula = formula.app_customervolumeformula;

        const formulaVolumeLand = volumeFormula.find((item) => item.route === "land");
        const formulaVolumeSea = volumeFormula.find((item) => item.route === "sea");
        // set formula volume sea
        formCustomerFormula.setFieldValue("volume_sea_from", formulaVolumeSea.volume_from);
        formCustomerFormula.setFieldValue("volume_sea_to", formulaVolumeSea.volume_to);
        formCustomerFormula.setFieldValue("volume_sea_a", formulaVolumeSea.a);
        formCustomerFormula.setFieldValue("volume_sea_b", formulaVolumeSea.b);
        formCustomerFormula.setFieldValue("volume_sea_c", formulaVolumeSea.c);
        formCustomerFormula.setFieldValue("volume_sea_d", formulaVolumeSea.d);
        formCustomerFormula.setFieldValue("volume_sea_e", formulaVolumeSea.e);
        // set formula volume land
        formCustomerFormula.setFieldValue("volume_land_from", formulaVolumeLand.volume_from);
        formCustomerFormula.setFieldValue("volume_land_to", formulaVolumeLand.volume_to);
        formCustomerFormula.setFieldValue("volume_land_a", formulaVolumeLand.a);
        formCustomerFormula.setFieldValue("volume_land_b", formulaVolumeLand.b);
        formCustomerFormula.setFieldValue("volume_land_c", formulaVolumeLand.c);
        formCustomerFormula.setFieldValue("volume_land_d", formulaVolumeLand.d);
        formCustomerFormula.setFieldValue("volume_land_e", formulaVolumeLand.e);
      }
      // Check formula weight is land or sea
      if (formula.app_customerweightformula.length > 0) {
        const weightFormula = formula.app_customerweightformula;

        const formulaWeightLand = weightFormula.find((item) => item.route === "land");
        const formulaWeightSea = weightFormula.find((item) => item.route === "sea");
        // set formula weight sea
        formCustomerFormula.setFieldValue("weight_sea_from", formulaWeightSea.weight_from);
        formCustomerFormula.setFieldValue("weight_sea_to", formulaWeightSea.weight_to);
        formCustomerFormula.setFieldValue("weight_sea_a", formulaWeightSea.a);
        formCustomerFormula.setFieldValue("weight_sea_b", formulaWeightSea.b);
        formCustomerFormula.setFieldValue("weight_sea_c", formulaWeightSea.c);
        formCustomerFormula.setFieldValue("weight_sea_d", formulaWeightSea.d);
        formCustomerFormula.setFieldValue("weight_sea_e", formulaWeightSea.e);
        // set formula weight land
        formCustomerFormula.setFieldValue("weight_land_from", formulaWeightLand.weight_from);
        formCustomerFormula.setFieldValue("weight_land_to", formulaWeightLand.weight_to);
        formCustomerFormula.setFieldValue("weight_land_a", formulaWeightLand.a);
        formCustomerFormula.setFieldValue("weight_land_b", formulaWeightLand.b);
        formCustomerFormula.setFieldValue("weight_land_c", formulaWeightLand.c);
        formCustomerFormula.setFieldValue("weight_land_d", formulaWeightLand.d);
        formCustomerFormula.setFieldValue("weight_land_e", formulaWeightLand.e);
      }
    }
  };

  const onSubmitFormula = async () => {
    const values = await formCustomerFormula.getFieldsValue();

    let formulaId = viewFormulaDataByOne.id;
    let customerId = viewFormulaDataByOne.customer_id;
    const prepareDataFormula = {
      customer_id: customerId,
      company_code: detailData.app_company.company_code,
      customer_code: detailData.customer_code,
      origin_name: viewFormulaDataByOne.app_warehouse_app_customerformula_origin_idToapp_warehouse.warehouse_code,
      destination_name:
        viewFormulaDataByOne.app_warehouse_app_customerformula_destination_idToapp_warehouse.warehouse_code,
      id: formulaId,
      threshold_a: Number(values.threshold_a),
      threshold_b: Number(values.threshold_b),
      threshold_c: Number(values.threshold_c),
      threshold_d: Number(values.threshold_d),
      threshold_e: Number(values.threshold_e),
      customer_volume_formula: [
        {
          route: "land",
          volume_from: Number(values.volume_land_from) || 0,
          volume_to: Number(values.volume_land_to) || 0,
          a: Number(values.volume_land_a) || 0,
          b: Number(values.volume_land_b) || 0,
          c: Number(values.volume_land_c) || 0,
          d: Number(values.volume_land_d) || 0,
          e: Number(values.volume_land_e) || 0,
        },
        {
          route: "sea",
          volume_from: Number(values.volume_sea_from) || 0,
          volume_to: Number(values.volume_sea_to) || 0,
          a: Number(values.volume_sea_a) || 0,
          b: Number(values.volume_sea_b) || 0,
          c: Number(values.volume_sea_c) || 0,
          d: Number(values.volume_sea_d) || 0,
          e: Number(values.volume_sea_e) || 0,
        },
      ],
      customer_weight_formula: [
        {
          route: "land",
          weight_from: Number(values.weight_land_from) || 0,
          weight_to: Number(values.weight_land_to) || 0,
          a: Number(values.weight_land_a) || 0,
          b: Number(values.weight_land_b) || 0,
          c: Number(values.weight_land_c) || 0,
          d: Number(values.weight_land_d) || 0,
          e: Number(values.weight_land_e) || 0,
        },
        {
          route: "sea",
          weight_from: Number(values.weight_sea_from) || 0,
          weight_to: Number(values.weight_sea_to) || 0,
          a: Number(values.weight_sea_a) || 0,
          b: Number(values.weight_sea_b) || 0,
          c: Number(values.weight_sea_c) || 0,
          d: Number(values.weight_sea_d) || 0,
          e: Number(values.weight_sea_e) || 0,
        },
      ],
    };

    if (viewFormulaDataByOne.app_customervolumeformula.length > 0) {
      let formulaVolume = viewFormulaDataByOne.app_customervolumeformula;

      //prepare data formula volume
      prepareDataFormula.customer_volume_formula = prepareDataFormula.customer_volume_formula.map((item) => {
        const matched = formulaVolume.find((formula) => formula.route === item.route);

        return {
          ...item,
          id: matched?.id,
        };
      });
    }

    if (viewFormulaDataByOne.app_customerweightformula.length > 0) {
      let formulaWeight = viewFormulaDataByOne.app_customerweightformula;

      //prepare data formula weight
      prepareDataFormula.customer_weight_formula = prepareDataFormula.customer_weight_formula.map((item) => {
        const matched = formulaWeight.find((formula) => formula.route === item.route);

        return {
          ...item,
          id: matched?.id,
        };
      });
    }

    setLoading(true);
    try {
      const response = await customerManagementService.updateCustomerFormula(
        accessToken,
        customerId,
        prepareDataFormula
      );
      openNotificationWithIcon(settings.NotificationType.SUCCESS, <>{"Success."}</>, <>{"update Success"}</>);
      setIsModalOpen(false);
      fetchCustomerFormula();
      setLoading(false);
    } catch (err) {
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      console.error("[ModelFormula] onSubmitFormula: ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (accessToken) {
      formCustomerFormula.setFieldValue();
      setFormulaData(viewFormulaDataByOne);
    }
  }, [accessToken, setFormulaData]);

  return (
    <>
      {contextHolder}
      <Modal
        title={t("Customer_Create.Create_Formula.Add_Edit_Formula")}
        open={isModalOpen}
        className="rounded-lg border-2"
        closable={true}
        centered={true}
        forceRender={true}
        width={1280}
        footer={() => (
          <>
            <Button type="primary" onClick={onSubmitFormula} loading={loading}>
              {t("BTN_Save", { ns: "buttons" })}
            </Button>
            <Button onClick={handleCancel}>{t("BTN_Cancel", { ns: "buttons" })}</Button>
          </>
        )}
      >
        <Col span={24}>
          <Form
            form={formCustomerFormula}
            labelAlign="left"
            labelCol={{
              flex: "140px",
            }}
          >
            <Form.Item
              label={t("Customer_Create.Create_Formula.Title") + ":"}
              name="origin"
              key="origin"
              style={{ marginBottom: "1rem" }}
            >
              <Title level={5}>
                {isModalOpen
                  ? `${viewFormulaDataByOne.app_warehouse_app_customerformula_origin_idToapp_warehouse.warehouse_code}
                    -
                    ${viewFormulaDataByOne.app_warehouse_app_customerformula_destination_idToapp_warehouse.warehouse_code}`
                  : ""}
              </Title>
            </Form.Item>
            <Form.Item
              label={t("Customer_Create.Create_Formula.Threshold_A") + ":"}
              name="threshold_a"
              key="threshold_a"
              style={{ marginBottom: "1rem" }}
            >
              <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
            </Form.Item>
            <Form.Item
              label={t("Customer_Create.Create_Formula.Threshold_B") + ":"}
              name="threshold_b"
              key="threshold_b"
              style={{ marginBottom: "1rem" }}
            >
              <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
            </Form.Item>
            <Form.Item
              label={t("Customer_Create.Create_Formula.Threshold_C") + ":"}
              name="threshold_c"
              key="threshold_c"
              style={{ marginBottom: "1rem" }}
            >
              <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
            </Form.Item>
            <Form.Item
              label={t("Customer_Create.Create_Formula.Threshold_D") + ":"}
              name="threshold_d"
              key="threshold_d"
              style={{ marginBottom: "1rem" }}
            >
              <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
            </Form.Item>
            <Form.Item
              label={t("Customer_Create.Create_Formula.Threshold_E") + ":"}
              name="threshold_e"
              key="threshold_e"
              style={{ marginBottom: "1rem" }}
            >
              <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
            </Form.Item>
            <Card
              style={{
                marginTop: 16,
              }}
              type="inner"
              title={t("Customer_Create.Create_Formula.Formula_Volume.Title")}
            >
              <Row gutter={24}>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Route")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Volume.Volume_Form")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Volume.Volume_To")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"A"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"B"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"C"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"D"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"E"}</div>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Land")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_from" key="volume_land_from" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_to" key="volume_land_to" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_a" key="volume_land_a" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_b" key="volume_land_b" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_c" key="volume_land_c" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_d" key="volume_land_d" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_land_e" key="volume_land_e" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Sea")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_from" key="volume_sea_from" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_to" key="volume_sea_to" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.000000" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_a" key="volume_sea_a" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_b" key="volume_sea_b" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_c" key="volume_sea_c" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_d" key="volume_sea_d" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="volume_sea_e" key="volume_sea_e" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Card>
            <Card
              style={{
                marginTop: 16,
              }}
              type="inner"
              title={t("Customer_Create.Create_Formula.Formula_Weight.Title")}
            >
              <Row gutter={24}>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Route")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Weight.Weight_Form")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Weight.Weight_To")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"A"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"B"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"C"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"D"}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>{"E"}</div>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Land")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_from" key="weight_land_from" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_to" key="weight_land_to" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_a" key="weight_land_a" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_b" key="weight_land_b" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_c" key="weight_land_c" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_d" key="weight_land_d" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_land_e" key="weight_land_e" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col className="gutter-row" span={3}>
                  <div>{t("Customer_Create.Create_Formula.Formula_Sea")}</div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_from" key="weight_sea_from" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_to" key="weight_sea_to" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_a" key="weight_sea_a" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_b" key="weight_sea_b" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_c" key="weight_sea_c" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_d" key="weight_sea_d" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
                <Col className="gutter-row" span={3}>
                  <div>
                    <Form.Item name="weight_sea_e" key="weight_sea_e" style={{ marginBottom: "1rem" }}>
                      <InputNumber allowClear={true} size="default" min={0} max={99999} step="1.00" />
                    </Form.Item>
                  </div>
                </Col>
              </Row>
            </Card>
          </Form>
        </Col>
      </Modal>
    </>
  );
};
